import React from 'react'
import { node, oneOf, string } from 'prop-types'

import InlineVideo from '@/component/Composition/InlineVideo'
import CaptionedMedia from '@/component/Primitive/CaptionedMedia'

const InlineVideoWidget = ({ caption, provider, videoId, videoCaption }) => {
  if (!videoCaption || videoCaption?.length === 0)
    return (
      <InlineVideo caption={caption} provider={provider} videoId={videoId} />
    )
  return (
    <CaptionedMedia caption={videoCaption.replace(/\n/g, '<br />')}>
      <InlineVideo provider={provider} videoId={videoId} />
    </CaptionedMedia>
  )
}

InlineVideoWidget.propTypes = {
  caption: node,
  provider: oneOf(['vimeo', 'youtube']),
  videoId: string,
  videoCaption: string
}

export default InlineVideoWidget
